var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.groupName))]),_vm._v(" "),_c('SelectIconGrid',{attrs:{"rows":_vm.entries,"name-field":"labelDisplay","description-field":"spec.description","key-field":"_key","icon-field":"spec.iconSrc","side-label-field":"spec.sideLabel","as-link":true,"target-field":"actualTarget","color-for":() => 'color1'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }